import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReset = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.5 8C14.5 11.6 11.6 14.5 8 14.5C4.4 14.5 1.5 11.6 1.5 8H2.5C2.5 11.05 4.95 13.5 8 13.5C11.05 13.5 13.5 11.05 13.5 8C13.5 4.95 11.05 2.5 8 2.5C4.95 2.5 4.4 3.45 3.4 5H6.5L5.5 6H2V2.5L3 1.5V3.85C4.2 2.35 6.05 1.5 8 1.5C11.6 1.5 14.5 4.4 14.5 8Z",
		fill: "currentColor"
	})
});
export default SvgReset;
